/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import { Link as NavLink, useLocation } from 'react-router-dom';
// RouterLink, 
import PropTypes from 'prop-types';
import {
  // Avatar,
  // Box,
  // Button,
  Collapse,
  // Divider,
  Drawer,
  Hidden,
  List,
  ListItem,
  ListItemText,
  TextField,
  // Typography,
} from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import PerfectScrollbar from 'perfect-scrollbar';
import AdminNavbarLinks from 'components/Navbars/AdminNavbarLinks.js';

import cx from 'classnames';

// import NavItem from './NavItem';

// import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle.js';
import UserSide from '../Setting/User/UserSide';
import withStyles from '@material-ui/core/styles/withStyles';
import MainSideBarStyle from 'assets/jss/material-dashboard-pro-react/components/tvendoSidebarStyle.js';
// import { activeRoute } from 'contexts/routeReducer';
// import { RouteAction } from 'contexts/routeReducer';
import { useApp } from 'hooks/useApp';
import { useAuth } from 'hooks/useAuth';
import Adornment from 'components/Tvendo/Common/Adornment';

let ps;

const SidebarWrapper = (props) => {
  const { className, userSide, headerLinks, links } = props;

  const sidebarWrapper = React.createRef();
  const searchRef = useRef();

  useEffect(() => {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(sidebarWrapper.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
    return () => {
      if (navigator.platform.indexOf('Win') > -1) {
        ps.destroy();
      }
    };
  }, []);

  const [search, setSearch] = useState(null);
  function onChangeSearch(e) {
    if (!!props.filterRoutes) {
      props.filterRoutes(e.target.value);
      setSearch(e.target.value);
    }
  }
  function resetFilter() {
    if (!!props.filterRoutes) {
      searchRef.current.value = '';
      props.filterRoutes('');
      searchRef.current.focus();
      setSearch(null);
    }
  }

  return (
    <>
      <div className={className} ref={sidebarWrapper}>
        {userSide}
        <div>
          <TextField
            defaultValue=''
            style={{
              marginTop: '10px',
              marginLeft: '15px',
              marginRight: '15px',
            }}
            variant="outlined" label="Buscar..."
            onChange={onChangeSearch} inputRef={searchRef}
            onKeyDown={e => {
              if (e.nativeEvent.key == "Escape") {
                resetFilter();
                e.target.blur();
              }
            }}
            InputLabelProps={{
              style: {
                color: 'white',
              },
            }}
            InputProps={{
              id: 'sidebar-search',
              style: {
                color: 'white',
              },
              endAdornment: <Adornment type="search" onClick={resetFilter} style={{
                color: 'white',
              }} search={search} />
            }}
          />
        </div>
        {headerLinks}
        {links}
      </div>
    </>
  );
};

const MainSideBar = ({
  onMobileClose,
  openMobile,
  openAvatar = false,
  miniActive = false,
  rtlActive = false,
  ...props
}) => {
  const { logo, image, logoText, bgColor, classes } = props;
  const mainPanel = React.createRef();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState(null);
  const [routes, setRoutes] = useState(null);
  const [filteredRoutes, setFilteredRoutes] = useState(null);
  const { getSidebarConfig } = useApp();
  const { allPermissions } = useAuth();

  useEffect(() => {
    if (activeRoute) {
      const _routes = getSidebarConfig({
        permissions: allPermissions(),
        location: activeRoute,
        type: 'node'
      });
      setRoutes(_routes);
      setFilteredRoutes(_routes);
    }
  }, [activeRoute]);

  useEffect(() => {
    let pathname = location.pathname;
    let lastSlash = location.pathname.lastIndexOf('/');
    if (lastSlash !== -1 && !isNaN(pathname.substring(lastSlash + 1))) {
      pathname = pathname.substring(0, lastSlash + 1);
    }

    const _routes = getSidebarConfig({
      permissions: allPermissions(),
      location: pathname,
      type: 'location'
    });
    setRoutes(_routes);
    setFilteredRoutes(_routes);
  }, [location]);

  function filterRoutes(search) {
    if (search === '') {
      setFilteredRoutes(routes);
    } else {
      setFilteredRoutes(recursiveFilter([...routes], search));
    }
  }

  function recursiveFilter(parentRoutes, search, deep = 0) {
    function parseString(title) {
      return title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '');
    }
    search = parseString(search);

    parentRoutes = [...parentRoutes];
    let newRoutes = parentRoutes.reduce((accRoutes, currentRoute) => {
      currentRoute = { ...currentRoute };
      if (!!currentRoute.children && Array.isArray(currentRoute.children) && currentRoute.children.length > 0) {
        if ('title' in currentRoute && parseString(currentRoute.title).includes(search)) {
          currentRoute.open = true;
          accRoutes.push(currentRoute);
        } else {
          currentRoute.children = recursiveFilter([...currentRoute.children], search, deep + 1);
          if (currentRoute.children.length > 0) {
            currentRoute.open = true;
            accRoutes.push(currentRoute);
          }
        }
      } else {
        if ('title' in currentRoute && parseString(currentRoute.title).includes(search)) {
          currentRoute.open = false;
          accRoutes.push(currentRoute);
        }
      }
      return accRoutes;
    }, []);
    return newRoutes;
  }

  // const itemText =
  //   classes.itemText +
  //   ' ' +
  //   cx({
  //     [classes.itemTextMini]: miniActive,
  //     [classes.itemTextMiniRTL]: miniActive && rtlActive,
  //     [classes.itemTextRTL]: rtlActive
  //   });
  // const collapseItemText =
  //   classes.collapseItemText +
  //   ' ' +
  //   cx({
  //     [classes.collapseItemTextMini]: miniActive,
  //     [classes.collapseItemTextMiniRTL]: rtlActive && miniActive,
  //     [classes.collapseItemTextRTL]: rtlActive
  //   });
  // const userWrapperClass =
  //   classes.user +
  //   ' ' +
  //   cx({
  //     [classes.whiteAfter]: bgColor === 'white'
  //   });
  // const caret =
  //   classes.caret +
  //   ' ' +
  //   cx({
  //     [classes.caretRTL]: rtlActive
  //   });
  // const collapseItemMini =
  //   classes.collapseItemMini +
  //   ' ' +
  //   cx({
  //     [classes.collapseItemMiniRTL]: rtlActive
  //   });
  // const photo = classes.photo + ' ' + cx({[classes.photoRTL]: rtlActive});
  const logoNormal = classes.logoNormal + ' ' + cx({
    [classes.logoNormalSidebarMini]: miniActive,
    [classes.logoNormalSidebarMiniRTL]: rtlActive && miniActive,
    [classes.logoNormalRTL]: rtlActive
  });
  const logoMini = classes.logoMini + ' ' + cx({ [classes.logoMiniRTL]: rtlActive });
  const logoClasses = classes.logo + ' ' + cx({ [classes.whiteAfter]: bgColor === 'white' });
  const brand = (
    <div className={logoClasses}>
      <a href="#" target="_blank" className={logoMini}>
        <img src={logo} alt="logo" className={classes.img} />
      </a>
      <a href="#" target="_blank" className={logoNormal}>
        {logoText}
      </a>
    </div>
  );
  const drawerPaper = classes.drawerPaper + ' ' + cx({
    [classes.drawerPaperMini]: miniActive,
    [classes.drawerPaperRTL]: rtlActive
  });
  const sidebarWrapper = classes.sidebarWrapper + ' ' + cx({
    [classes.drawerPaperMini]: miniActive,
    [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location]);

  const userSide = (
    <UserSide
      classes={classes}
      routes={routes}
      logoText={props.logoText}
      logo={logo}
      image={image}
      handleDrawerToggle={props.handleDrawerToggle}
      open={props.mobileOpen}
      color={props.color}
      bgColor={bgColor}
      miniActive={miniActive}
      {...props}
    />
  );

  const [openMenu, setOpenMenu] = useState(false);

  const isActiveRoute = (routeName) => {
    return location.pathname === routeName ? 'active' : '';
  };
  const createLinks = (routes, props) => {
    const { classes, color, rtlActive } = props;

    if (!routes) return;
    const menu = routes.map((prop, key) => {
      if (prop.locked) return;

      if (prop.collapse) {
        const navLinkClasses =
          classes.itemLink +
          ' ' +
          cx({
            [' ' + classes.collapseActive]: prop.open
          });
        const itemText =
          classes.itemText +
          ' ' +
          cx({
            [classes.itemTextMini]: miniActive,
            [classes.itemTextMiniRTL]: rtlActive && miniActive,
            [classes.itemTextRTL]: rtlActive
          });
        const collapseItemText =
          classes.collapseItemText +
          ' ' +
          cx({
            [classes.collapseItemTextMini]: miniActive,
            [classes.collapseItemTextMiniRTL]: rtlActive && miniActive,
            [classes.collapseItemTextRTL]: rtlActive
          });
        const itemIcon =
          classes.itemIcon +
          ' ' +
          cx({
            [classes.itemIconRTL]: rtlActive
          });
        const caret =
          classes.caret +
          ' ' +
          cx({
            [classes.caretRTL]: rtlActive
          });
        const collapseItemMini =
          classes.collapseItemMini +
          ' ' +
          cx({
            [classes.collapseItemMiniRTL]: rtlActive
          });
        return (
          <ListItem
            key={key}
            className={cx(
              { [classes.item]: prop.icon !== undefined },
              { [classes.collapseItem]: prop.icon === undefined }
            )}
          >
            <NavLink
              to={'#'}
              className={navLinkClasses}
              onClick={(e) => {
                e.preventDefault();
                setOpenMenu(!openMenu);
                prop.open = !prop.open;
                /**
                 * Esta linea causaba errores en el sidebar
                 */
                // setActiveRoute(prop.open ? null : prop.key);
              }}
            >
              {prop.icon !== undefined ? (
                typeof prop.icon === 'string' ? (
                  <Icon className={itemIcon}>{prop.icon}</Icon>
                ) : (
                  <prop.icon className={itemIcon} />
                )
              ) : (
                <span className={collapseItemMini}>{rtlActive ? prop.rtlMini : prop.mini}</span>
              )}
              <ListItemText
                primary={`${prop.title.replaceAll('_', ' ')}`}
                /* primary={`${rtlActive ? prop.rtlName : prop.name} ${prop.fullPath} `} */
                secondary={<b className={`${caret} ${(prop.open ? classes.caretActive : '')}`} />}
                disableTypography={true}
                className={cx(
                  { [itemText]: prop.icon !== undefined },
                  { [collapseItemText]: prop.icon === undefined }
                )}
              />
            </NavLink>
            {/* <Collapse in={[prop.state]} unmountOnExit> */}
            <Collapse in={prop.open} unmountOnExit>
              <List className={classes.list + ' ' + classes.collapseList}>
                {createLinks(prop.children, props)}
              </List>
            </Collapse>
          </ListItem>
        );
      }
      const innerNavLinkClasses =
        classes.collapseItemLink +
        ' ' +
        cx({
          // [' ' + classes[color]]: isActiveRoute(prop.path)
          [' ' + classes[color]]: prop.open ? 'active' : ''
        });
      const collapseItemMini =
        classes.collapseItemMini +
        ' ' +
        cx({
          [classes.collapseItemMiniRTL]: rtlActive
        });
      const navLinkClasses =
        classes.itemLink +
        ' ' +
        cx({
          // [' ' + classes[color]]: isActiveRoute(prop.path)
          [' ' + classes[color]]: prop.open ? 'active' : ''
        });
      const itemText =
        classes.itemText +
        ' ' +
        cx({
          [classes.itemTextMini]: miniActive,
          [classes.itemTextMiniRTL]: rtlActive && miniActive,
          [classes.itemTextRTL]: rtlActive
        });
      const collapseItemText =
        classes.collapseItemText +
        ' ' +
        cx({
          [classes.collapseItemTextMini]: miniActive,
          [classes.collapseItemTextMiniRTL]: rtlActive && miniActive,
          [classes.collapseItemTextRTL]: rtlActive
        });
      const itemIcon = classes.itemIcon + ' ' + cx({ [classes.itemIconRTL]: rtlActive });
      return (
        <ListItem
          key={key}
          className={cx(
            { [classes.item]: prop.icon !== undefined },
            { [classes.collapseItem]: prop.icon === undefined }
          )}
        >
          <NavLink
            to={prop.path ? prop.path : '#'}
            className={cx(
              { [navLinkClasses]: prop.icon !== undefined },
              { [innerNavLinkClasses]: prop.icon === undefined }
            )}
          >
            {prop.icon !== undefined ? (
              typeof prop.icon === 'string' ? (
                <Icon className={itemIcon}>{prop.icon}</Icon>
              ) : (
                <prop.icon className={itemIcon} />
              )
            ) : (
              <span className={collapseItemMini}>{rtlActive ? prop.rtlMini : prop.mini}</span>
            )}
            <ListItemText
              primary={prop.title.replaceAll('_', ' ')}
              /* primary={`${rtlActive ? prop.rtlName : prop.name} ${prop.fullPath} `} */
              disableTypography={true}
              className={cx(
                { [itemText]: prop.icon !== undefined },
                { [collapseItemText]: prop.icon === undefined }
              )}
            />
          </NavLink>
        </ListItem>
      );
    });
    return menu;
  };

  const links = <List className={classes.list}>{createLinks(filteredRoutes, { ...props, classes })}</List>;
  return (
    <div ref={mainPanel}>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={rtlActive ? 'left' : 'right'}
          open={props.open}
          classes={{
            paper: drawerPaper + ' ' + classes[bgColor + 'Background']
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <SidebarWrapper
            className={sidebarWrapper}
            userSide={userSide}
            headerLinks={<AdminNavbarLinks rtlActive={rtlActive} />}
            links={links}
            filterRoutes={filterRoutes}
          />
          {image !== undefined ? (
            <div className={classes.background} style={{ backgroundImage: 'url(' + image + ')' }} />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          onMouseOver={() => (props.miniActive = false)}
          onMouseOut={() => (props.miniActive = true)}
          anchor={rtlActive ? 'right' : 'left'}
          variant="permanent"
          open
          classes={{
            paper: drawerPaper + ' ' + classes[bgColor + 'Background']
          }}
        >
          {brand}
          <SidebarWrapper className={sidebarWrapper} userSide={userSide} links={links} filterRoutes={filterRoutes} />
          {image !== undefined ? (
            <div className={classes.background} style={{ backgroundImage: 'url(' + image + ')' }} />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
};

MainSideBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(['white', 'black', 'blue']),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf(['white', 'red', 'orange', 'green', 'blue', 'purple', 'rose']),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func
};

MainSideBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false,
  bgColor: 'blue'
};

export default withStyles(MainSideBarStyle)(MainSideBar);
